import { getSavedFormReferrer, deleteSavedReferrer } from './components/forms/helpers'
import { sanitizeUrl } from './components/helpers'

document.addEventListener('DOMContentLoaded', () => {
  const formReturnLink = document.querySelector('[data-form-back-link]')
  const savedReferrer = getSavedFormReferrer()
  if (formReturnLink && savedReferrer) {
    deleteSavedReferrer()
    formReturnLink.setAttribute('href', sanitizeUrl(savedReferrer))
  }
})
